<script>
import ConversationForm from './ConversationForm.vue';

export default {
  components: {
    ConversationForm,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    contact: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    'contact.id'(id) {
      this.fetchContactableInboxes(id);
    },
  },
  mounted() {
    this.fetchContactableInboxes(this.contact.id);
  },
  methods: {
    // A action relanca o erro (outros chamadores mostram a mensagem). Aqui a
    // busca sai sozinha, de watcher e de mounted, e sem o `catch` a rejeicao
    // ia solta para o console (#1625). Sem as caixas o formulario ja mostra a
    // lista vazia; nao ha o que avisar alem disso.
    async fetchContactableInboxes(id) {
      if (!id) return;
      try {
        await this.$store.dispatch('contacts/fetchContactableInbox', id);
      } catch {
        // ver o comentario acima
      }
    },
    onCancel() {
      this.$emit('cancel');
    },
    onSuccess() {
      this.$emit('cancel');
    },
    async onSubmit(params, isFromWhatsApp) {
      const data = await this.$store.dispatch('contactConversations/create', {
        params,
        isFromWhatsApp,
      });
      return data;
    },
  },
};
</script>

<!-- eslint-disable vue/no-mutating-props -->
<template>
  <woot-modal :show.sync="show" :on-close="onCancel">
    <div class="flex flex-col h-auto overflow-auto">
      <woot-modal-header
        :header-title="$t('NEW_CONVERSATION.TITLE')"
        :header-content="$t('NEW_CONVERSATION.DESC')"
      />
      <ConversationForm
        :contact="contact"
        :on-submit="onSubmit"
        @success="onSuccess"
        @cancel="onCancel"
      />
    </div>
  </woot-modal>
</template>
